// extracted by mini-css-extract-plugin
export default {"overlay":"Tooltip_overlay__P2pNU","isWhite":"Tooltip_isWhite__bC2ve","isDark":"Tooltip_isDark__KQZbr"};